import Loader from "react-loader-spinner";
import { Fragment, useRef, useState } from "react";
import { Button, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { setDialog } from "../../store/api/Modals";
import { useForm } from "react-hook-form";
import { addNewEvent, deleteEvent, getCustomerEvents } from "../../store/api/CustomerApi";
import { CheckLg, DashCircleFill, List, PlusSquare, Search } from "react-bootstrap-icons";
import DatePicker from "react-datepicker2";
import "react-datepicker2/src/styles/style.css";
import ModalSelectUser from "../../../Components/Modals/ModalSelectUser";
import BihamtaTable from "../../../Components/BihamtaTable";
//let totalPage = 0;
const CustomerEvents = (props) => {


    const dateTo = useRef();
    const dateFrom = useRef();
    const currPage = useRef(1);
    const eventData = useRef({});
    const dispatch = useDispatch();
    const { register, handleSubmit } = useForm();
    const { customerID, isPreCustomer } = props;
    const [pending, setPending] = useState(false);
    const [selectedUser, selectUser] = useState(null);
    const [eventError, setEventError] = useState({});
    const [modalUsers, setModalUsers] = useState({ show: false });
    const searchData = useRef({ Take: 10, Skip: 0, CustomerID: customerID, IsStaff: false, IsPreCustomer: isPreCustomer ?? false });
    const [showAddEvent, setShowAddEvent] = useState(false);
    const { typeList } = useSelector(state => {
        return {
            typeList: state.customerDataReducer.eventTypeList
        }
    });
    const search = (data) => {
        if (selectedUser && selectedUser.ID) {
            searchData.current.CreateById = selectedUser.ID;
        }
        if (dateFrom.current.input.value === "") {
            searchData.current.DateFrom = null;
        }
        if (dateTo.current.input.value === "") {
            searchData.current.DateTo = null;
        }
        searchData.current.Skip = currPage.current - 1;
        searchData.current.CustomerID = customerID;
        searchData.current.IsPreCustomer = isPreCustomer ?? false;
        searchData.current.IsStaff = false;
        searchData.current.Take = 10;
        Object.assign(searchData.current, data);
        dispatch(getCustomerEvents(searchData.current));
    }
    const addEvent = () => {
        let er = {};
        if (!eventData.current.Description || eventData.current.Description === '') {
            er.Description = 'N';
        }
        if (!eventData.current.EventTypeID || eventData.current.EventTypeID === "") {
            er.EventTypeID = 'N';
        }
        setEventError(er);
        if (er.EventTypeID || er.Description) {
            return;
        }
        setPending(true);
        eventData.current.CustomerID = customerID;
        eventData.current.IsPreCustomer = isPreCustomer ?? false;
        const onSuccess = () => {
            setPending(false);
            let searchData = {};
            searchData.Skip = 0;
            searchData.CustomerID = customerID;
            searchData.IsPreCustomer = isPreCustomer ?? false;
            searchData.IsStaff = false;
            searchData.Take = 10;
            eventData.current = {};
            setShowAddEvent(false);
            dispatch(getCustomerEvents(searchData));
        }
        dispatch(addNewEvent(eventData.current, onSuccess));
    }
    const cancelEvent = () => {
        eventData.current = {};
        setEventError({});
        setShowAddEvent(false);
    }
    const showUserPOP = () => {
        setModalUsers({ show: true, selectUserWithName: selectUser });
    }
    function gotoEventAttachment(row) {
        if (row.Description.includes("حذف")) {
            return;
        }
        if (row.AttachmentType === "Sale" ||
            row.AttachmentType === "PreSale" ||
            row.AttachmentType === "Purchase" ||
            row.AttachmentType === "PrePurchase" || row.AttachmentType?.includes("Formal")) {
            const isFormal = row.AttachmentType.includes("Formal");
            window.open(`/Sale/Invoice/${row.AttachmentType.replace("Formal", "")}/${row.AttachmentID}/${isFormal}`)
        }
        else if (row.AttachmentType === "repair" || row.AttachmentType === "install") {
            window.open(`/Services/Service/${row.AttachmentID}/${row.AttachmentType}`);
        }
    }
    const tableColes = [
        { colTitle: "تاریخ رویداد", colName: "PCreationDate", showInMobile: true },
        { colTitle: "شرح رویداد", colName: "Description", showInMobile: true, maxTextLength: 150, colType: "string", hasTooltip: true },
        { colTitle: "نوع رویداد", colName: "EventTypeStr", showInMobile: false },
        { colTitle: "تاریخ پیگیری", colName: "pNextDate", showInMobile: false },
        { colTitle: "ثبت کننده", colName: "CreateByName", showInMobile: false },
        { colTitle: "جزئیات بیشتر", colName: "MoreDetails", showInMobile: false }

    ]
    const tableRowButtons = [
        {
            title: "حذف رویداد", type: "delete", className: "group-Btn-smalll btn-danger", onclick: (item) => {
                dispatch(setDialog({
                    status: 'show',
                    arrayBtn: ['yes', 'no'],
                    dialogTitle: 'حذف رویداد',
                    dialogText: 'آیا از حذف مطمئن هستید؟',
                    okOperation: deleteEvent(item.ID, search)
                }))
            }
        }

    ]
    return (
        <Fragment>
            <ModalSelectUser popData={modalUsers} setUserPop={setModalUsers} />
            {!showAddEvent &&
                <div style={{ border: "1px solid #b1b1b1", borderRadius: "3px", padding: "5px", paddingBottom: "15px", margin: "5px" }}>
                    <form onSubmit={handleSubmit(search)}>
                        <div className="row" >
                            <div className="col-md-2 form-group">
                                <label>نوع رویداد</label>
                                <select className="form-control" name="EventTypeID" ref={register({})}>
                                    <option value="">انتخاب کنید</option>
                                    {typeList && Array.isArray(typeList) &&
                                        typeList.map((item, i) => <option key={i} value={item.ID}>{item.InfoName}</option>)}
                                </select>
                            </div>
                            <div className="col-md-1 form-group">
                                <label>از تاریخ</label>
                                <DatePicker ref={dateFrom} isGregorian={false} timePicker={false} className="form-control"
                                    onChange={value => { searchData.current.DateFrom = value.local("en").format("YYYY/MM/DD") }} />
                            </div>
                            <div className="col-md-1 form-group">
                                <label>تا تاریخ</label>
                                <DatePicker ref={dateTo} isGregorian={false} timePicker={false} className="form-control"
                                    onChange={value => { searchData.current.DateTo = value.local("en").format("YYYY/MM/DD") }} />
                            </div>
                            <div className="col-md-2 form-group">
                                <label style={{ display: "block" }}>شرح رویداد</label>
                                <input type="text" className="form-control" name="Description" ref={register({})} />
                            </div>
                            <div className="col-md-2 form-group">
                                <label style={{ display: "block" }}>جزئیات بیشتر</label>
                                <input type="text" className="form-control" name="MoreDetails" ref={register({})} />
                            </div>
                            <div className="col-md-2 form-group">
                                <label style={{ display: "block" }}>ثبت کننده</label>
                                <input type="text" className="form-control" readOnly value={selectedUser ? selectedUser.Name : ""} />
                                <Button className="btn-input-tiny" onClick={showUserPOP} style={{ top: 27 }}><List size={22} /></Button>
                            </div>
                            <Col md={2} style={{ display: "flex", alignItems: "flex-end", paddingBottom: "2px" }}>
                                <Button type="submit" variant="secondary" className="group-Btn-large"><Search />&nbsp;جستجوی رویداد</Button>
                            </Col>
                        </div>
                    </form>

                </div>
            }
            {showAddEvent &&
                <div style={{ border: "1px solid #b1b1b1", borderRadius: "3px", padding: "5px" }}>
                    <div className="row">
                        <div className="col-md-2 form-group">
                            <label>نوع رویداد</label><span style={{ color: "red", fontSize: "14px" }}>*</span>
                            <select className="form-control" onChange={e => eventData.current.EventTypeID = e.target.value}>
                                <option value="">انتخاب کنید</option>
                                {typeList && Array.isArray(typeList) &&
                                    typeList.map((item, i) => <option key={i} value={item.ID}>{item.InfoName}</option>)}
                            </select>
                            {eventError.EventTypeID && <small className="errors">نوع رویداد الزامی است</small>}
                        </div>
                        <div className="col-md-2 form-group">
                            <label>تاریخ پیگیری</label>
                            <DatePicker name="AlarmDate" isGregorian={false} timePicker={false} className="form-control"
                                onChange={value => { eventData.current.NextDate = value.local("en").format("YYYY/MM/DD") }} />
                        </div>
                        <div className="col-md-6 form-group">
                            <label>شرح رویداد</label><span style={{ color: "red", fontSize: "14px" }}>*</span>
                            <input className="form-control" onChange={e => eventData.current.Description = e.target.value} />
                            {eventError.Description && <small className="errors">شرح رویداد الزامی است</small>}
                        </div>

                    </div>
                    <Button variant="success" className="group-Btn mt-2" onClick={addEvent}>
                        {!pending && <Fragment><CheckLg />&nbsp;ثبت رویداد</Fragment>}
                        {pending && <Fragment> <Loader type="BallTriangle" color="white" height={15} width={15} style={{ display: "inline-block" }} />&nbsp; منتظر بمانید</Fragment>}
                    </Button>
                    <Button variant="danger" className="group-Btn mt-2" onClick={cancelEvent}><DashCircleFill size={16} />&nbsp;انصراف</Button>
                </div>
            }
            {!showAddEvent && <Button className="group-Btn-smalll" style={{ textAlign: "center" }} onClick={() => setShowAddEvent(true)}><PlusSquare size={18} /></Button>}
            <BihamtaTable columns={tableColes} rowButtons={tableRowButtons} reducerName="customerDataReducer" objectName="customerEventList" hasPaging={true}
                rowClick={gotoEventAttachment} filterData={searchData.current} searchMethod={(data) => dispatch(getCustomerEvents(data))} />

        </Fragment >
    )
}
export default CustomerEvents;